import { Injectable } from '@angular/core';
import { Subject ,  Observable, BehaviorSubject } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class AppBreadcrumbService {

    private itemCache = [];
    private itemsSource = new Subject<MenuItem[]>();    
    private queryParams = {url: '', params: {}};
    private queryParamsList = [];
    itemsHandler = this.itemsSource.asObservable();

    public calendar: MenuItem = { id: '1', label: 'Calendar', routerLink: 'calendar' };
    public dataMining: MenuItem = { id: '2', label: 'Data Mining', routerLink: 'datamining-search' };
    public messageBoard: MenuItem= { id:'3', label: 'Message Board', routerLink: 'message/view' };
    public messageAdd: MenuItem= { id: '4', label: 'Add', routerLink: 'message/add' };
    public news: MenuItem= { id: '5', label: 'News', routerLink: '/' };
    public newsAdd: MenuItem= { id: '6', label: 'Add', routerLink: 'news/add' };
    public help: MenuItem= { id: '7', label: 'Help & Support', routerLink: 'help' };
    public user: MenuItem= { id: '8', label: 'User', routerLink: 'user/view' };
    public userInvite: MenuItem = { id: '9', label: 'Invite a Professional', routerLink: 'user/invite' };
    public member: MenuItem = { id: '10', label: 'Member', routerLink: 'member/view' };
    public memberAdd: MenuItem = { id: '11', label: 'Add', routerLink: 'member/new' };
    public memberEdit: MenuItem = { id: '14', label: 'Edit', routerLink: 'member/edit' };
    public deal: MenuItem = { id: '12', label: 'Deal', routerLink: 'deal/view' };
    public dealAdd: MenuItem = { id: '13', label: 'Add', routerLink: 'deal/add' };
    public report: MenuItem = { id: '15', label: 'Reports', routerLink: 'report' };
    public search: MenuItem = { id: '16', label: 'Search', routerLink: 'search' };

    beforePreviousUrl: string = '';
    previousUrl: string = '';
    currentUrl: string = '';

    public crumb: MenuItem;
    constructor(router: Router) {
        router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.beforePreviousUrl = this.previousUrl;
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
            });
    }

    setItems(items: MenuItem[]) {
        if (this.previousUrl == '/search' && (this.currentUrl.includes('/user/') || this.currentUrl.includes('/member/'))) {
            items.unshift(this.search);
        }
        this.itemsSource.next(items);
        switch (this.currentUrl) {
            //for Search screen: only load parms when search -> member or user -> search
            case '/search':
                if (!(this.beforePreviousUrl == '/search' && (this.previousUrl.includes('/user/') || this.previousUrl.includes('/member/')))) {
                    this.queryParamsList = this.queryParamsList.filter(x => x.url !== this.search.url);
                }
                break;
        }
       
    }

    saveQueryParams(url, params) {
        this.queryParams = { url: url, params: params };
        let isFound = this.queryParamsList.some(element => {
            if (element.url === url) {
                return true;
            }
        });
        if (!isFound)
            this.queryParamsList.push(this.queryParams);
        else {
            this.queryParamsList.forEach((value, index) => {
                if (value.url == url)
                    this.queryParamsList.splice(index, 1);
            });
            this.queryParamsList.push(this.queryParams);
        }
    }

    getQueryParams(url) {
        return this.queryParamsList.filter(x => x.url == url)[0];
    }
}
